import { render } from "./XsList.vue?vue&type=template&id=154ed606&scoped=true&ts=true"
import script from "./xsListHelper.ts?vue&type=script&lang=ts"
export * from "./xsListHelper.ts?vue&type=script&lang=ts"

import "./XsList.vue?vue&type=style&index=0&id=154ed606&scoped=true&lang=css"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154ed606"]])

export default __exports__